const MESSAGES_ROOT_ROUTE = '/messages' as const;

export const MESSAGES_ROUTES = {
  MESSAGES: MESSAGES_ROOT_ROUTE,
  SINGLE_MESSAGE_THREAD: `${MESSAGES_ROOT_ROUTE}/:messageId`,
  NEW_MESSAGE: `${MESSAGES_ROOT_ROUTE}/new`,
  NEW_MESSAGE_SUB_PAGE: `${MESSAGES_ROOT_ROUTE}/new/:topicId/:subTopicId?`,
  NOTICE_PAGE: `${MESSAGES_ROOT_ROUTE}/notices/:noticeId`,
} as const;
